import { Theme } from '@mui/material';
import { TButtonVariantStyle } from '@mui/material/styles';
import { css, CSSObject } from 'styled-components';

import { TButtonSize } from './button-common.types';

export const ICON_DIMENSIONS = {
  large: '1.25rem',
  medium: '1.25rem',
  small: '1rem',
  extraSmall: '1rem',
} as const;

export const iconStyles = ({ $size }: { $size: TButtonSize }) => css`
  svg,
  .MuiCircularProgress-root,
  .MuiCircularProgress-svg {
    height: ${ICON_DIMENSIONS[$size]} !important;
    width: ${ICON_DIMENSIONS[$size]} !important;
  }
`;

// Size-related styles
export const getSizeStyles = (theme: Theme) => {
  return ({ $size }: { $size: TButtonSize }) => {
    const typographyStyle = {
      large: theme.typography.button1,
      medium: theme.typography.button1,
      small: theme.typography.button2,
      extraSmall: theme.typography.button2,
    }[$size];

    return css`
      border-radius: ${theme.shape.buttonRadius?.[$size]};
      height: ${theme.shape.buttonHeight?.[$size]};
      min-width: ${theme.shape.buttonHeight?.[$size]};
      ${typographyStyle as CSSObject};
      ${iconStyles({ $size })};
    `;
  };
};

export const getClickedBoxShadow = (color: string) => css`
  box-shadow: 0 0 0 2px ${color};
`;

export const getBorderStyle = (color: string) => css`
  box-shadow: inset 0 0 0 1px ${color};
`;

export const getVariantStyles = (
  theme: Theme,
  variant: keyof TButtonVariantStyle,
) => {
  return ({ $clicked }: { $clicked?: boolean }) => {
    return css`
      color: ${theme.palette.button[variant].color};
      background-color: ${theme.palette.button[variant].background};
      ${theme.palette.button[variant].border &&
      getBorderStyle(theme.palette.button[variant].border)};
      ${$clicked &&
      getClickedBoxShadow(theme.palette.button[variant].clickedShadow)};

      svg {
        color: ${theme.palette.button[variant].color};
      }

      &:hover {
        background-color: ${theme.palette.button[variant].hoverBackground};
      }

      &:disabled {
        color: ${theme.palette.button[variant].color};
        background-color: ${theme.palette.button[variant].background};
        svg {
          color: ${theme.palette.button[variant].color};
        }
      }
    `;
  };
};
